import { render, staticRenderFns } from "./FormatsTab.vue?vue&type=template&id=7d22952e&scoped=true"
import script from "./FormatsTab.vue?vue&type=script&lang=js"
export * from "./FormatsTab.vue?vue&type=script&lang=js"
import style0 from "./FormatsTab.vue?vue&type=style&index=0&id=7d22952e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d22952e",
  null
  
)

export default component.exports